<template>
  <div>
    <b-row>
      <b-col
        md="6"
        xl="6"
        class="mb-1"
      >
        <b-col
          md="12"
          xl="12"
          class="mb-1"
        >

          <b-card-code>
            <b-row style="margin-top: -2em; margin-bottom: 1em">
              <b-col
                md="8"
                xl="8"
              >
                <div class="font-medium-3 font-weight-bold">Allgemeine Informationen</div>
              </b-col>
              <b-col
                md="4"
                xl="4"
              >
                <b-badge class="float-right ml-1 cursor-pointer" variant="secondary" @click="OldSync()">Sync</b-badge>
                <b-badge class="float-right" variant="secondary" v-show="customer.CustomerType == 0">Keine Zuordnung</b-badge>
                <b-badge class="float-right" variant="info" v-show="customer.CustomerType == 1">Crew</b-badge>
                <b-badge class="float-right" variant="success" v-show="customer.CustomerType == 2">Reisebüro</b-badge>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                md="4"
                xl="4"
              >
                <b-form-group
                  label="Kundennummer"
                >
                  <b-form-input
                    v-model="customer.CustomerNumber"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                md="6"
                xl="6"
              >
                <b-form-group
                  label="Name"
                >
                  <b-form-input
                    v-model="customer.Name"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="6"
                xl="6"
              >
                <b-form-group
                  label="Kontaktname"
                >
                  <b-form-input
                    v-model="customer.Contact.Name"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-code>
        </b-col>

        <b-col
          md="12"
          xl="12"
          class="mb-1"
        >
          <b-card-code>

            <b-row style="margin-top: -2em; margin-bottom: 1em">
              <b-col
                md="8"
                xl="8"
              >
                <div class="font-medium-3 font-weight-bold">Adressinformationen</div>
              </b-col>
              <b-col
                md="4"
                xl="4"
              >
              </b-col>
            </b-row>
            <b-row>
              <b-col
                md="12"
                xl="12"
              >
                <b-form-group
                  label="Strasse"
                >
                  <b-form-input
                    v-model="customer.Address.Street"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col
                md="4"
                xl="4"
              >
                <b-form-group
                  label="Postleitzahl"
                >
                  <b-form-input
                    v-model="customer.Address.ZipCode"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="8"
                xl="8"
              >
                <b-form-group
                  label="Ort"
                >
                  <b-form-input
                    v-model="customer.Address.Location"
                  />
                </b-form-group>
              </b-col>
            </b-row>

          </b-card-code>
        </b-col>

        <b-col
          md="12"
          xl="12"
          class="mb-1"
        >
          <b-card-code>

            <b-row style="margin-top: -2em; margin-bottom: 1em">
              <b-col
                md="8"
                xl="8"
              >
                <div class="font-medium-3 font-weight-bold">Kontaktinformationen</div>
              </b-col>
              <b-col
                md="4"
                xl="4"
              >
              </b-col>
            </b-row>

            <b-row>
              <b-col
                md="4"
                xl="4"
              >
                <b-form-group
                  label="Telefon"
                >
                  <b-form-input
                    v-model="customer.Contact.Phone"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="4"
                xl="4"
              >
                <b-form-group
                  label="Telefon"
                >
                  <b-form-input
                    v-model="customer.Contact.Phone2"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="4"
                xl="4"
              >
                <b-form-group
                  label="Fax"
                >
                  <b-form-input
                    v-model="customer.Contact.Fax"
                  />
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col
                md="6"
                xl="6"
              >
                <b-form-group
                  label="Email"
                >
                  <b-form-input
                    v-model="customer.Contact.Email"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="6"
                xl="6"
              >
                <b-form-group
                  label="Webseite"
                >
                  <b-form-input
                    v-model="customer.Contact.Web"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-code>
        </b-col>

        <b-col
          md="12"
          xl="12"
          class="mb-1"
        >
          <b-card-code>

            <b-row style="margin-top: -2em; margin-bottom: 1em">
              <b-col
                md="8"
                xl="8"
              >
                <div class="font-medium-3 font-weight-bold">Zahlungsinformationen</div>
              </b-col>
              <b-col
                md="4"
                xl="4"
              >
              </b-col>
            </b-row>
            <b-row>
              <b-col
                md="3"
                xl="3"
              >
                <b-form-group
                  label="Mehrwertsteuersatz (%)"
                >
                  <b-form-select
                    v-model="customer.VatId"
                    :options="VatList"
                    @change="SelectVat"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="3"
                xl="3"
              >
                <b-form-group
                  label="Mehrwertsteuerart"
                >
                  <b-form-select
                    v-model="customer.VatType"
                    :options="VatTypeList"
                    @change="SelectVat"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="3"
                xl="3"
              >
                <b-form-group
                  label="Provisionssatz"
                >
                  <b-form-input
                    v-model="customer.Commission"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="3"
                xl="3"
              >
                <b-form-group
                  label="Buchungsbestätigung"
                >
                  <b-form-select
                    v-model="customer.BookingConfirmation"
                    :options="BookingConfirmationList"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                md="3"
                xl="3"
              >
                <b-form-group
                  label="E-Mail (Rechnung)"
                >
                  <b-form-input
                    v-model="customer.EmailBilling"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="3"
                xl="3"
              >
                <b-form-group
                  label="Rechnungsstellung"
                >
                  <b-form-select
                    v-model="customer.BillingRun"
                    :options="BillingRunList"
                    @change="SelectVat"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="3"
                xl="3"
              >
                <b-form-group
                  label="Rechnungsversand"
                >
                  <b-form-select
                    v-model="customer.InvoiceDispatch"
                    :options="InvoiceDispatchList"
                    @change="SelectVat"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="3"
                xl="3"
              >
                <b-form-group
                  label="Zahlart"
                >
                  <b-form-select
                    v-model="customer.PaymentMethod"
                    :options="PaymentMethodList"
                  />
                </b-form-group>
              </b-col>

            </b-row>

          </b-card-code>
        </b-col>

        <b-col
          md="12"
          xl="12"
          class="mb-1"
        >


          <b-card-code>
            <b-row style="margin-top: -2em; margin-bottom: 1em">
              <b-col
                  md="8"
                  xl="8"
              >
                <div class="font-medium-3 font-weight-bold">Steuerinformationen</div>
              </b-col>
              <b-col
                  md="4"
                  xl="4"
              >
              </b-col>
            </b-row>
            <b-row>
              <b-col
                  md="6"
                  xl="6"
              >
                <b-form-group
                    label="Umsatzsteuer-ID"
                >
                  <b-form-input
                      v-model="customer.TaxDetails.VatNumber"
                      placeholder="DE000000000"
                  />
                </b-form-group>
              </b-col>
              <b-col
                  md="6"
                  xl="6"
              >
                <b-form-group
                    label="Steuernummer"
                >
                  <b-form-input
                      v-model="customer.TaxDetails.TaxNumber"
                      placeholder="000/000/00000"
                  />
                </b-form-group>
              </b-col>
            </b-row>


          </b-card-code>
          <b-card-code>
            <b-row style="margin-top: -2em; margin-bottom: 1em">
              <b-col
                md="8"
                xl="8"
              >
                <div class="font-medium-3 font-weight-bold">Bankinformationen</div>
              </b-col>
              <b-col
                md="4"
                xl="4"
              >
              </b-col>
            </b-row>
            <b-row>
              <b-col
                md="12"
                xl="12"
              >
                <b-form-group
                  label="Kontoinhaber"
                >
                  <b-form-input
                    v-model="customer.BankDetails.AccountOwner"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                md="6"
                xl="6"
              >
                <b-form-group
                  label="Iban"
                >
                  <b-form-input
                    v-model="customer.BankDetails.Iban"
                  />
                </b-form-group>
              </b-col>
              <b-col
                md="6"
                xl="6"
              >
                <b-form-group
                  label="Bic"
                >
                  <b-form-input
                    v-model="customer.BankDetails.Bic"
                  />
                </b-form-group>
              </b-col>
            </b-row>

          </b-card-code>


          <b-card-code style="height: 20em">
            <b-row style="margin-top: -2em; margin-bottom: 1em">
              <b-col
                  md="12"
                  xl="12"
              >
                <div class="font-medium-3 font-weight-bold">Interne Info</div>
              </b-col>
            </b-row>
            <b-row>
              <quill-editor
                  v-model="customer.Info"
                  :options="editorOption"
                  style="height: 12em; width: 100%"
              >
                <div
                    id="toolbar"
                    slot="toolbar"
                    class="text-white"
                >
                  <!-- Add a bold button -->
                  <button class="ql-bold">
                    Boldsadasd
                  </button>
                  <button class="ql-italic">
                    Italic
                  </button>

                  <!-- Add font size dropdown -->
                  <select class="ql-size">
                    <option value="small"/>
                    <!-- Note a missing, thus falsy value, is used to reset to default -->
                    <option selected/>
                    <option value="large"/>
                    <option value="huge"/>
                  </select>

                  <select class="ql-font">
                    <option selected="selected"/>
                    <option value="serif"/>
                    <option value="monospace"/>
                  </select>

                  <!-- Add subscript and superscript buttons -->
                  <button
                      class="ql-script"
                      value="sub"
                  />
                  <button
                      class="ql-script"
                      value="super"
                  />

                </div>
              </quill-editor>
            </b-row>

          </b-card-code>

          <b-card-code>
            <b-row style="margin-top: -2em; margin-bottom: 1em">
              <b-col
                md="8"
                xl="8"
              >
                <div class="font-medium-3 font-weight-bold">Homepage Account</div>
              </b-col>
              <b-col
                md="4"
                xl="4"
              >
                <b-button
                  variant="info"
                  class="btn-block btn-sm"
                  @click="CreateAccount"
                >
                  Account erstellen
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-table
                striped
                hover
                responsive
                :items="accounts"
                :fields="accountFields"
              >
                <template #cell(Locked)="data">
                  <b-badge
                    v-show="data.item.Locked"

                    class="mt-1 mr-1"
                    variant="danger"
                  >Ja
                  </b-badge>
                  <b-badge
                    v-show="!data.item.Locked"

                    class="mt-1 mr-1"
                    variant="success"
                  >Nein
                  </b-badge>
                </template>
              </b-table>
            </b-row>

          </b-card-code>
        </b-col>


        <b-card-code>
          <b-button
            class="col-4"
            variant="danger"
            @click="DeleteEntry()"
            v-show="customer.IdentId > 0"
          >
            <span v-show="!loading"> Löschen </span>
            <!-- IF YOU ARE USING VUE BOOTSTRAP USE <b-spinner label="Loading..."></b-spinner> -->
            <div
              v-show="loading"
              class="spinner-border spinner-border-sm"
              role="status"
            >
              <span class="sr-only">Loading...</span>
            </div>
          </b-button>
          <b-button
            v-show="customer.IdentId > 0"
            style="float: right"
            class="col-7"
            variant="info"
            @click="Save()"
          >
            <span v-show="!loading"> Speichern  </span>
            <!-- IF YOU ARE USING VUE BOOTSTRAP USE <b-spinner label="Loading..."></b-spinner> -->
            <div
              v-show="loading"
              class="spinner-border spinner-border-sm"
              role="status"
            >
              <span class="sr-only">Loading...</span>
            </div>
          </b-button>
          <b-button
            v-show="customer.IdentId == 0"
            style="float: right"
            class="col-7"
            variant="info"
            @click="Add()"
          >
            <span v-show="!loading"> Anlegen  </span>
            <!-- IF YOU ARE USING VUE BOOTSTRAP USE <b-spinner label="Loading..."></b-spinner> -->
            <div
              v-show="loading"
              class="spinner-border spinner-border-sm"
              role="status"
            >
              <span class="sr-only">Loading...</span>
            </div>
          </b-button>
        </b-card-code>

      </b-col>
      <b-col
        md="6"
        xl="6"
        class="mb-1"
      >



        <b-card-code title="Dateien" v-if="customer.IdentId > 0">
          <b-row>
            <b-col
                cols="12"
            >
              <b-button @click="$root.$emit('OpenFileMenu', 2, customer.IdentId)">Neue Datei</b-button>
              <FileBoxedView class="mt-2" ref="customerFileView"></FileBoxedView>
            </b-col>
          </b-row>
        </b-card-code>

        <b-card-code title="SevDesk" v-if="customer.IdentId > 0">
          <b-row>
            <b-col
                cols="6"
            >
              Sevdesk ID: {{customer.SevDeskId}}
            </b-col>
            <b-col
                cols="6"
            >
              <b-button class="btn-sm btn-block btn-danger" v-if="customer.SevDeskId != ''" @click="DeleteSevDeskConnection">Verbindung lösen</b-button>
              <b-button class="btn-sm btn-block btn-info" v-if="customer.SevDeskId == ''" @click="AddSevDeskConnection">Sevdesk Kontakt erstellen</b-button>
            </b-col>
          </b-row>
        </b-card-code>

        <b-card-code title="History">
          <b-row>
            <b-col
              cols="12"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="center"
                size="sm"
                class="my-0 mb-1"
              />
              <b-table
                striped
                hover
                responsive
                :items="history"
                :fields="fields"
                @filtered="onFiltered"
                @row-clicked="clickVoucher"
              >
                <template #cell(Vid)="data">{{ data.item.Vid }}
                  <b-badge
                    v-show="data.item.BillNumber != ''"

                    class="mt-1 mr-1"
                    variant="success"
                  >Rechnung {{ data.item.BillNumber }}
                  </b-badge>
                  <b-badge
                    v-show="data.item.SevDeskCreditNoteId != null && data.item.SevDeskCreditNoteId != ''"
                    class="ml-1 mt-2" style="color: #e8e8e8; background: #007b8d; cursor: pointer;"
                  >
                    Gutschrift: {{ data.item.SevDeskCreditNoteId }}
                  </b-badge>
                  <b-badge
                    v-show="data.item.Canceled != null && data.item.Canceled == true"
                    :title="(data.item.Canceled + ' ('+data.item.CanceledUser+')')"
                    variant="warning"
                  >Storniert
                  </b-badge>
                </template>
                <template #cell(PickupTime)="data">
                  {{ data.item.TravelDay }} - {{ data.item.PickupTime }}
                </template>
                <template #cell(Passenger)="data">
                  {{ data.item.Passenger.Passengers }} / {{ data.item.Passenger.PassengersChildren }}
                </template>
                <template #cell(Route)="data">
                  {{ data.item.PickUpAddress.Name }} => {{ data.item.DestinationAddress.Name }}
                </template>
                <template #cell(Price)="data">
                  <b-badge
                    variant="light-info"
                  >{{ data.item.Price.PriceFull }}
                  </b-badge>
                </template>
              </b-table>

            </b-col>
          </b-row>
        </b-card-code>
      </b-col>
    </b-row>


  </div>
</template>

<script>
// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import BCardCode from '@core/components/b-card-code'
import { BAvatar, BBadge, BButton, BCol, BFormGroup, BFormInput, BFormSelect, BInputGroup, BInputGroupAppend, BPagination, BRow, BTable } from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import Ripple from 'vue-ripple-directive'
import 'animate.css'
import FileBoxedView from '@/layouts/components/FileBoxedView.vue'

export default {
  name: 'Customer',
  components: {
    quillEditor,
    FileBoxedView,
    BCardCode,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      totalRows: 0,
      perPage: 50,
      currentPage: 1,
      history: [],

      fields: [
        {
          key: 'Vid',
          label: 'V-Data',
        },
        {
          key: 'PickupTime',
          label: 'Abholung',
        },
        {
          key: 'Passenger',
          label: 'Personen',
        },
        {
          key: 'Price',
          label: 'Preis',
        },
        {
          key: 'Route',
          label: 'Strecke',
        },
        {
          key: 'Info',
          label: 'Info',
        },
      ],
      loading: false,
      accounts: [],

      editorOption: {
        modules: {
          toolbar: '#toolbar',
        },
      },
      accountFields: [
        {
          key: 'UserId',
          label: 'Id',
        },
        {
          key: 'Username',
          label: 'Benutzername',
        },
        {
          key: 'Locked',
          label: 'Gesperrt',
        },
      ],
      ConnectTargets: [],
      customer: {
        Id: '',
        IdentId: 0,
        CustomerNumber: '',
        Name: '',
        Address: {
          Street: '',
          ZipCode: '',
          Location: '',
          District: null
        },
        Contact: {
          Name: '',
          Phone: '',
          Phone2: '',
          Fax: '',
          Email: '',
          Web: ''
        },
        BillingRun: 0,
        VatId: 1,
        PaymentMethod: 1,
        BookingConfirmation: 0,
        VatType: 0,
        EmailBilling: '',
        InvoiceDispatch: 1,
        Commission: 0,
        SevDeskId: "",
        BankDetails: {
          AccountOwner: null,
          Iban: '',
          Bic: ''
        },
        TaxDetails: {
          TaxNumber: '',
          VatNumber: ''
        },
        AdditionalAddress: '',
        Info: ''
      },
      PaymentMethodList: [{
        value: 0,
        text: 'Keine'
      }, {
        value: 1,
        text: 'Rechnung'
      }, {
        value: 2,
        text: 'Lastschrift'
      }, {
        value: 3,
        text: 'Barzahlung'
      }],
      BookingConfirmationList: [{
        value: 0,
        text: 'Keine'
      }, {
        value: 1,
        text: 'Ja per E-Mail'
      }],
      VatList: [{
        value: 0,
        text: 'Kein Mehrwertsteuersatz (0%)'
      }],
      VatTypeList: [{
        value: 0,
        text: 'zzgl. MwSt.'
      },
        {
          value: 1,
          text: 'inkl. MwSt.'
        }],
      BillingRunList: [{
        value: 0,
        text: 'Keine Rechnungsstellung'
      }, {
        value: 1,
        text: 'Tägliche Rechnungsstellung'
      }, {
        value: 2,
        text: 'Anfang und Mitte eines Monats'
      }, {
        value: 3,
        text: 'Immer zum Anfang eines Monats'
      }],
      InvoiceDispatchList: [{
        value: 0,
        text: 'Keinen Rechnungsversand'
      }, {
        value: 1,
        text: 'Rechnung per E-Mail'
      }, {
        value: 2,
        text: 'Rechnung per Post'
      }, {
        value: 3,
        text: 'Rechnung per E-Post'
      }],
      startData: null
    }
  },
  created() {
  },
  mounted() {
    this.$nextTick(() => {
      document.title = 'Kunde'
    })
    this.LoadVatList()
    this.LoadCustomer()
    this.LoadHistory()

    this.$watch(
      () => this.customer,
      val => {
        console.log('change')
      },
    )
  },
  methods: {
    AddSevDeskConnection() {
      this.$swal({
        title: 'SevDesk Kontakt',
        text: 'Möchten Sie wirklich einen SevDesk Kontakt erstellen?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ja!',
        cancelButtonText: 'Nein, abbrechen',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
          .then(result => {
            if (result.isConfirmed) {
              this.$http.post('/customer/sevdesk/add/' + this.customer.CustomerNumber, JSON.stringify("[]"))
                  .then(resp => {
                    if (resp.data.success) {
                      this.customer.SevDeskId = resp.data.sevdeskId;
                      this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: 'Info',
                          icon: 'CheckIcon',
                          text: 'Zugewiesene SevDeskId: ' + resp.data.sevdeskId,
                          variant: 'success',
                        },
                      })
                    }
                  })
                  .catch(err => {
                    console.error(err)
                  })
            }
          })
    },
    DeleteSevDeskConnection() {

      this.$swal({
        title: 'SevDesk',
        text: 'Möchten Sie die verknüpfung zu Sevdesk wirklich lösen?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ja, lösen!',
        cancelButtonText: 'Nein, abbrechen',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
          .then(result => {
            if (result.value) {
              this.$http.delete('/customer/sevdesk/connection/'+this.customer.IdentId)
                  .then(resp => {
                    if (resp.data.success) {
                      this.loading = false
                      this.customer.SevDeskId = "";
                      this.$toast({
                        component: ToastificationContent,
                        props: {
                          title: 'Info',
                          icon: 'CheckIcon',
                          text: 'Verknüpfung wurde gelöst.',
                          variant: 'success',
                        },
                      })
                    } else {
                      this.loading = false
                      resp.data.errors.forEach(data => {
                        this.$toast({
                          component: ToastificationContent,
                          props: {
                            title: 'Fehler ' + data.Code,
                            icon: 'CheckIcon',
                            text: data.Message,
                            variant: 'danger',
                          },
                        })
                      })
                    }
                  })
                  .catch(err => {
                    console.error(err)
                  })
            }
          })
    },
    CreateAccount() {

      let createData = {
        UserId: 0,
        Locked: false,
        Username: 'K'+this.customer.CustomerNumber,
        UserType: 1,
        PushoverId: 0,
        Address: this.customer.Address,
        Contact: this.customer.Contact,
        Rights: [],
        GoogleId: 0,
        Customer: [],

      }

      this.$swal({
        title: 'Neuer Account',
        text: 'Möchten Sie einen neuen Account für die Website erstellen?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ja, erstellen!',
        cancelButtonText: 'Nein, abbrechen',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
        .then(result => {
          if (result.value) {
            this.$http.post('/api/user/create?customerIdentId=' + this.$route.params.id, JSON.stringify(createData))
              .then(resp => {
                if (resp.data.success) {
                  this.loading = false
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Info',
                      icon: 'CheckIcon',
                      text: 'Benutzer wurde erstellt.',
                      variant: 'success',
                    },
                  })
                  this.GetAccounts();
                } else {
                  this.loading = false
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: 'Fehler',
                      icon: 'CheckIcon',
                      text: resp.data.errorMessage,
                      variant: 'danger',
                    },
                  })
                }
              })
              .catch(err => {
                console.error(err)
              })
          }
        })

    },
    GetAccounts() {
      this.$http.get('/api/user/list/by/customer/' + this.$route.params.id)
        .then(resp => {
          if (resp.status != 200) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Info',
                icon: 'CheckIcon',
                text: 'Server gibt einen Ungültigen Code zurück (' + resp.status + ').',
                variant: 'success',
              },
            })
            return
          }
          this.accounts = resp.data.list
        })
        .catch(err => {
          console.error(err)
        })

    },
    async LoadCustomer() {
      if (this.$route.params.id > 0) {
        await this.$http.get('/customer/customerId/' + this.$route.params.id)
          .then(resp => {
            if (resp.status != 200) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Info',
                  icon: 'CheckIcon',
                  text: 'Server gibt einen Ungültigen Code zurück (' + resp.status + ').',
                  variant: 'success',
                },
              })
              return
            }
            if(resp.data.TaxDetails == null) {
              resp.data.TaxDetails = {
                VatNumber : '',
                TaxNumber : '',
              }
            }
            this.customer = resp.data
            this.ConnectTargets = resp.data.ConnectTargets
            this.startData = this.customer
            this.$nextTick(() => {
              document.title = 'Knr. ' + this.customer.CustomerNumber
            })
            this.GetAccounts()

          })
          .catch(err => {
            console.error(err)
          })

        this.ConnectTargets.forEach(i => {
          if(i.TargetType == 7) {
            console.log(i)
            this.$refs.customerFileView.getFile(i.TargetId)
          }
        })
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    clickVoucher(record, index) {
      this.$router.push({
        name: 'VoucherMask',
        params: { id: record.Vid }
      })
    },
    LoadHistory() {
      const c1 = (this.currentPage - 1) * this.perPage
      this.history = []
      this.$http.get(`/voucher/by/customer/list?customerIdentId=${this.$route.params.id}&sortBy=travelDay&descending=true&from=${c1}&count=${this.perPage}`)
        .then(resp => {
          this.totalRows = resp.data.info.fullEntries
          resp.data.list.forEach(i => {
            this.history.push(i)
          })
        })
        .catch(err => {
          console.error(err)
        })
    },
    DeleteEntry() {
      this.$swal({
        title: 'LÖSCHEN',
        text: 'Möchten sie den Kunden ' + this.customer.Name + ' wirklich löschen?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ja, löschen!',
        cancelButtonText: 'Nein, abbrechen',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
        .then(result => {
          if (result.value) {
            this.$http.delete('customer/delete/' + this.customer.IdentId)
              .then(resp => {
                if (resp.data.success) {
                  this.$swal({
                    icon: 'success',
                    title: 'Gelöscht!',
                    text: 'Kunde wurde unwiderruflich gelöscht.',
                    customClass: {
                      confirmButton: 'btn btn-success',
                    },
                  })

                  this.$router.push({ name: 'customerList' })

                }
              })
              .catch(err => {
                console.error(err)
              })

          }
        })
    },
    Add() {
      if (this.loading) {
        return
      }

      this.loading = true
      delete this.customer.Id
      delete this.customer.IdentId
      this.$http.post('/customer/add', JSON.stringify(this.customer))
        .then(resp => {
          console.log(resp)
          if (resp.data.success) {
            this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Info',
                  icon: 'CheckIcon',
                  text: 'Kunde wurde angelegt. Neue Kundennummer ' + resp.data.newCustomerNumber,
                  variant: 'success',
                }
              },
              {
                timeout: 60000,
              })

            this.$router.push({
              name: 'customer',
              params: { id: resp.data.newIdentId }
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Fehler',
                icon: 'CheckIcon',
                text: resp.data.message,
                variant: 'danger',
              },
            })
          }
          setTimeout(() => {
            this.loading = false
          }, 1500)
        })
        .catch(err => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error',
              icon: 'CheckIcon',
              text: err,
              variant: 'danger',
            },
          })
        })
      console.log(this.customer)
    },
    Save() {
      if (this.loading) {
        return
      }

      this.loading = true
      delete this.customer.Id
      this.$http.post('/customer/save', JSON.stringify(this.customer))
        .then(resp => {
          console.log(resp)
          if (resp.data.success) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Info',
                icon: 'CheckIcon',
                text: 'Kunde wurde gespeichert.',
                variant: 'success',
              },
            })
          } else {
            resp.data.errors.forEach(data => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Fehler ' + data.Code,
                  icon: 'CheckIcon',
                  text: data.Message,
                  variant: 'danger',
                },
              })

            })
          }
          setTimeout(() => {
            this.loading = false
          }, 1500)
        })
        .catch(err => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error',
              icon: 'CheckIcon',
              text: err,
              variant: 'danger',
            },
          })
        })
      console.log(this.customer)
    },
    OldSync() {
      this.$http.get('/customer/sync/' + this.customer.CustomerNumber)
        .then(resp => {
          if (resp.data.success) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Success',
                icon: 'CheckIcon',
                text: 'Sync Abgeschlossen (erneut aufrufen)',
                variant: 'info',
              },
            })
          }
        })
        .catch(err => {

          console.error(err)
        })
    },
    SelectVat() {
      this.$http.post('vat/list')
        .then(resp => {
          resp.data.forEach(i => {
            this.VatList.push({
              value: i.VatId,
              text: i.Name + ' (' + i.Amount + '%)',
            })
          })
        })
        .catch(err => {

          console.error(err)
        })
      console.log(this.customer
      )
    },
    LoadVatList() {
      this.$http.get('vat/list')
        .then(resp => {
          resp.data.forEach(i => {
            this.VatList.push({
              value: i.VatId,
              text: i.Name + ' (' + i.Amount + '%)',
            })
          })
        })
        .catch(err => {
          console.error(err)
        })
    },
  }

}
</script>

<style scoped>

</style>
